import { INavMenu } from "@layouts/components/nav.model";
import { ROLES } from '@shared/models/user';
import { uriConsts } from '@shared/constants';


export const navItems: INavMenu[] = [
  {
    path: 'conversation',
    display: 1,
    role: ROLES.Business_Staff,
    permission: 'conversation',
    title: 'common.conversation', //  Hội thoại
    icon: 'fal fa-comments-alt',
    url: uriConsts.chat.CONVERSATION_INDEX
  },
  {
    path: 'feature',
    display: 1,
    role: ROLES.Business_Staff,
    title: 'common.feature',
    icon: 'fal fa-video',
    children: [

      {
        path: '',
        display: 1,
        role: ROLES.Business_Staff,
        title: 'common.feature.introduction',
        icon: 'fal fa-cog',
        url: uriConsts.feature.INDEX
      },
      {
        display: 2,
        role: ROLES.Business_Staff,
        originTitle: 'Livestream',
        permission: 'live',
        icon: 'fal fa-video',
        path: 'live',
        children: [
          {
            path: 'shopping',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.shopping',
            permission: 'live_shopping',
            icon: 'fa-sharp-duotone fal fa-clipboard-check',
            url: uriConsts.live.LIVE_CHAT_SHOPPING_LIST,
          },
          {
            path: 'livestream',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.manage_livestream',
            permission: 'live_stream',
            icon: 'fal fa-video',
            url: uriConsts.live.LIVE_CHAT_LIVESTREAM,
          },
          {
            path: 'printcomments',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.print_comments',
            permission: 'live_print_comments',
            icon: 'fal fa-print',
            url: uriConsts.live.LIVE_PRINT_COMMENTS,
          },
          {
            path: 'checkliveads',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.check_live-ads',
            permission: 'live_checkliveads',
            icon: 'fal fa-check',
            url: uriConsts.live.LIVE_VIDEO_ADS,
          },
          {
            path: 'setting',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.live.setting_livestream',
            permission: 'live_setting',
            icon: 'fal fa-gear',
            url: uriConsts.live.LIVE_CHAT_SETTING,

          },
        ]
      },
      {
        display: 2,
        role: ROLES.Business_Staff,
        originTitle: 'Chatbot',
        permission: 'chatbot',
        icon: 'fa-sharp-duotone fal fa-robot',
        path: 'chatbot',
        children: [
          {
            path: 'list',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'common.feature.chatbot_script',
            permission: 'chatbot_script',
            icon: ' fal fa-message-bot',
            url: uriConsts.feature.CHATBOT_LIST,
          },
          {
            path: 'genai',
            display: 1,
            role: ROLES.Business_Staff,
            title: 'Chatbot AI',
            permission: 'chatbot_ai',
            icon: 'fa-sharp-duotone fal fa-robot',
            url: uriConsts.feature.CHATBOT_GENAI,
          },
        ]
      },
      {
        display: 1,
        role: ROLES.Business_Staff,
        path: 'chase',
        title: 'common.feature.chase_scenario',
        icon: 'fal fa-clock-rotate-left',
        permission: 'chatbot_automationcalender',
        url: uriConsts.feature.CHATBOT_AUTOMATIONCALENDER,

      },
      {
        display: 1,
        title: 'common.message.automation',
        role: ROLES.Business_Staff,
        path: 'automationInbox',
        icon: 'fal fa-paper-plane',
        permission: 'chatbot_automationinbox',
        url: uriConsts.feature.CHATBOT_AUTOMATIONINBOX,
      },
      {
        display: 1,
        title: 'common.custom_audience',
        path: 'audience',
        icon: 'fal fa-database',
        role: ROLES.Business_Staff,
        permission: 'chatbot_marketing',
        url: uriConsts.feature.CHATBOT_AUDIENCE,
      },
      {
        display: 1,
        title: 'common.message.marketing',
        icon: 'fal fa-bullhorn',
        path: 'marketing',
        role: ROLES.Business_Staff,
        permission: 'chatbot_marketing',
        url: uriConsts.feature.CHATBOT_MARKETING,
      },
      {
        display: 1,
        title: 'common.message.utility',
        icon: 'fal fa-gear',
        path: 'utilityMessage',
        role: ROLES.Business_Staff,
        permission: 'chatbot_utilitymessage',
        url: uriConsts.feature.CHATBOT_UTILITYMESSAGE
      },
      // {
      //   display: 0,
      //   role: ROLES.Business_Staff,
      //   title: 'Chatbot V2',
      //   permission: 'chatbot',
      //   isNewFeature: true,
      //   path: '/feature/chatbot/list',
      // },
      {
        display: 1,
        role: ROLES.Business_Staff,
        icon: 'fal fa-clock-rotate-left',
        title: 'common.order.auto.care',
        permission: 'chatbot_ecomcustomercare',
        path: 'ecomcustomercare',
        url: uriConsts.feature.CHATBOT_ECOMCUSTOMERCARE
      }
    ]
  },
  {
    path: 'order',
    display: 2,
    role: ROLES.Business_Staff,
    permission: 'order',
    title: 'common.order', // Đơn hàng
    icon: 'fal fa-shopping-bag',
    children: [
      {
        path: 'order',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'order_order',
        title: 'common.order',
        icon: 'fal fa-shopping-bag',
        url: uriConsts.order.ORDER_INDEX,
      },
      {
        path: 'draft',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'order_draft',
        title: 'common.order.draft', // đơn nháp
        icon: 'fal fa-clipboard-list',
        url: uriConsts.order.ORDER_DRAFT,
      },
    ]
  },
  {
    path: 'customer',
    display: 1,
    role: ROLES.Page_Admin,
    permission: 'customer',
    title: 'common.customer', // khách hàng
    icon: 'fal fa-user-friends',
    url: uriConsts.customer.CUSTOMER_INDEX
  },
  {
    path: 'setting',
    display: 1,
    role: ROLES.Business_Staff,
    permission: 'setting',
    title: 'common.setting', // cài đặt
    icon: 'fal fa-cog',
    url: uriConsts.settings.SETTING_INDEX,
    children: [
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
      {
        path: 'general',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_personalaccount',
        title: 'common.personalAccount', // cài đặt chung đối với tài khoản cá nhân
        icon: 'far fa-user-cog',
      },
      {
        path: 'conversation',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_conversation',
        title: 'common.conversation', //  Hội thoại
        hasRoleRedirect: '/setting/general', // nếu k có quyền vào /conversation thì chuyển hướng về /general
        icon: 'fal fa-comments-alt',
        url: uriConsts.settings.SETTING_CONVERSATION
      },
      {
        path: 'division',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_division',
        title: 'common.chat.splitConversation', // chia hội thoại
        icon: 'fal fa-comment-alt-edit',
        url: uriConsts.settings.SETTING_DIVISION
      },
      {
        path: 'tag',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_tag',
        title: 'common.chat.labelConversation', // nhãn hội thoại
        icon: 'fal fa-tags',
        url: uriConsts.settings.SETTING_TAG
      },
      {
        path: 'quickmsg',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_quickmsg',
        title: 'common.chat.instantMessaging', // tin nhắn nhanh
        icon: 'fal fa-envelope',
        url: uriConsts.settings.SETTING_QUICK_MSG
      },
      {
        path: 'ecomcustomercare',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_ecomcustomercare',
        title: 'common.order.autoOrderCare', // chăm sóc đơn hàng tự động
        icon: 'fal fa-message-bot',
        url: uriConsts.settings.SETTING_ECOM_CUSTOMER_CARE
      },
      {
        path: 'form',
        display: 0,
        role: ROLES.Business_Manager,
        originTitle: 'Form',
        icon: 'fa-light fa-memo-pad',
        url: uriConsts.settings.SETTING_FORM
      },
      {
        path: 'manageposts',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_manageposts',
        title: 'common.article', // Bài viết
        icon: 'fal fa-newspaper',
        url: uriConsts.settings.SETTING_MANAGE_POSTS
      },
      {
        path: 'managepage',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'setting_managepage',
        title: 'common.listPages', //Quản lý pages
        icon: 'fal fa-calendar-exclamation',
        url: uriConsts.settings.SETTING_MANAGE_PAGE
      },
      {
        path: 'user',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'setting_user',
        title: 'common.staff', // nhân viên
        icon: 'fal fa-users',
        url: uriConsts.settings.SETTING_USER
      },
      {
        path: 'metasmc',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'setting_metasmc',
        title: 'common.shopping.ShoppingOnMes', // mua sắm trên Messenger
        icon: 'fa-brands fa-facebook-messenger',
        url: uriConsts.settings.SETTING_META_SM
      },
      {
        path: 'sendpurchase',
        display: 1,
        role: ROLES.Business_Staff,
        permission: 'setting_sendpurchase',
        originTitle: 'Meta Conversions API',
        icon: 'fa-brands fa-meta',
        url: uriConsts.settings.SETTING_SEND_PURCHASE
      },
      {
        path: 'affiliate',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_affiliate',
        title: 'common.marketing.affiliateMarketing', // tiếp thị liên kết
        icon: 'fa-solid fa-users-line',
        url: uriConsts.settings.SETTING_AFFILIATE
      },
      {
        path: 'log',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'setting_log',
        title: 'common.setting.history', // lịch sử cài đặt
        icon: 'fal fa-history',
        url: uriConsts.settings.SETTING_LOG
      },
      {
        path: 'extension',
        display: 1,
        role: ROLES.Business_Staff,
        originTitle: 'Extension',
        icon: 'fa-regular fa-file-code',
        url: uriConsts.settings.SETTING_EXTENSION
      },
    ]
  },
  {
    path: 'report',
    display: 2,
    role: ROLES.Page_Admin,
    permission: 'report',
    title: 'common.report', // báo cáo
    icon: 'fal fa-chart-line',
    children: [
      {
        path: 'dashboard',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_dashboard',
        title: 'common.dashboard', // tổng quan
        icon: 'fal fa-tachometer-alt',
        url: uriConsts.report.DASHBOARD_INDEX
      },
      {
        path: 'page',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_page',
        title: 'common.page', // trang
        icon: 'fal fa-flag',
        url: uriConsts.report.PAGE_INDEX
      },
      {
        path: 'interactive',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_interactive',
        title: 'common.interact', // tương tác
        icon: 'fal fa-chart-network',
        url: uriConsts.report.DASHBOARD_INTERACTIVE
      },
      {
        path: 'staff',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report_staff',
        title: 'common.staff', // nhân viên
        icon: 'fal fa-user-chart',
        children: [
          {
            path: 'staff',
            display: 1,
            role: ROLES.Page_Admin,
            title: 'common.report.employee',
            permission: 'report_staff',
            icon: 'fal fa-chart-bar',
            url: uriConsts.report.DASHBOARD_STAFF
          },
          {
            path: 'activity',
            display: 1,
            role: ROLES.Business_Manager,
            title: 'common.active_time',
            permission: 'report_staff',
            icon: 'fal fa-user-chart',
            url: uriConsts.report.DASHBOARD_ACTIVITY
          }
        ]
      },
      {
        path: 'tag',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_tag',
        title: 'common.chat.labelConversation', // nhãn hội thoại
        icon: 'fal fa-tags',
        url: uriConsts.report.DASHBOARD_TAG
      },
      {
        path: 'post',
        display: 1,
        role: ROLES.Page_Admin,
        title: 'common.article',
        permission: 'report_post',
        icon: 'fal fa-tags',
        url: uriConsts.report.DASHBOARD_POST,
      },
      {
        path: 'fbad',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_fbad',
        originTitle: 'Facebook Ads',
        icon: 'fal fa-ad',
        url: uriConsts.report.DASHBOARD_FBAD
      },
      {
        path: 'facebook/metacapi',
        display: 1,
        role: ROLES.Page_Admin,
        permission: 'report_metacapi',
        title: 'common.order.createOderToMeta', // tạo đơn hàng sang meta
        icon: 'fal fa-cart-plus',
        url: uriConsts.report.DASHBOARD_METACAPI
      },
      {
        path: 'liveshopping',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report_liveshopping',
        title: 'common.order.autoCreateOrder', // chốt đơn tự động
        icon: 'fal fa-video',
        url: uriConsts.report.DASHBOARD_LIVESHOPPING
      },
      {
        path: 'livestreams',
        display: 1,
        role: ROLES.Business_Manager,
        permission: 'report_livestreams',
        originTitle: 'Live Streams',
        icon: 'fal fa-airplay',
        url: uriConsts.report.DASHBOARD_LIVESTREAMS
      },
    ]
  },
  // {
  //   path: 'sys',
  //   display: 2,
  //   role: ROLES.Blog_Editor,
  //   permission: 'system',
  //   title: 'common.system', // hệ thống
  //   icon: 'fal fa-database',
  //   children: [
  //     {
  //       path: 'pages',
  //       display: 1,
  //       role: ROLES.Admin,
  //       title: 'common.listPages', // Danh sách pages
  //       icon: 'fab fa-facebook',
  //       url: uriConsts.sys.SYS_PAGES
  //     },
  //     {
  //       path: 'users',
  //       display: 1,
  //       role: ROLES.Admin,
  //       title: 'common.user.listUser', // Danh sách user
  //       icon: 'fal fa-user-cog',
  //       url: uriConsts.sys.SYS_USERS
  //     },
  //     {
  //       path: 'payment',
  //       display: 1,
  //       role: ROLES.Admin,
  //       title: 'common.order.transactionList', // danh sách giao dịch
  //       icon: 'fal fa-money-check-alt',
  //       url: uriConsts.sys.SYS_PAYMENT
  //     },
  //     {
  //       path: 'report-user',
  //       display: 1,
  //       role: ROLES.SuperAdmin,
  //       title: 'common.report.user', // báo cáo người dùng
  //       icon: 'fal fa-chart-line',
  //       url: uriConsts.sys.SYS_REPORT_USER
  //     },
  //     {
  //       path: 'report-page-conversation',
  //       display: 1,
  //       role: ROLES.SuperAdmin,
  //       title: 'common.report.conversation', // báo cáo hội thoại
  //       icon: 'fal fa-comments',
  //       url: uriConsts.sys.SYS_REPORT_PAGE_CONVERSATION
  //     },
  //     {
  //       path: 'report-fbevent',
  //       display: 1,
  //       role: ROLES.SuperAdmin,
  //       originTitle: 'FB event logs',
  //       icon: 'fal fa-file-chart-line',
  //       url: uriConsts.sys.SYS_REPORT_FBEVENT
  //     },
  //     {
  //       path: 'blogs',
  //       display: 1,
  //       role: ROLES.Blog_Editor,
  //       title: 'common.article', // bài viết
  //       icon: 'fal fa-newspaper',
  //       url: uriConsts.sys.SYS_BLOGS
  //     },
  //     {
  //       path: 'author',
  //       display: 1,
  //       role: ROLES.Blog_Editor,
  //       title: 'common.article.author', // tác giả
  //       icon: "fa-light fa-user-graduate",
  //       url: uriConsts.sys.SYS_AUTHOR
  //     },
  //     {
  //       path: 'mobile-app',
  //       display: 0,
  //       role: ROLES.SuperAdmin,
  //       title: 'common.app.listMobileApp', // Danh sách mobile app
  //       icon: 'fal fa-mobile-alt',
  //       url: uriConsts.sys.SYS_MOBILE_APP
  //     },
  //     {
  //       path: 'manual',
  //       display: 0,
  //       role: ROLES.Admin,
  //       title: 'common.article.instructionManual', // hướng dẫn sử dung
  //       icon: 'fal fa-book',
  //       url: uriConsts.sys.SYS_MANUAL
  //     },
  //     {
  //       path: 'proxy',
  //       display: 1,
  //       role: ROLES.SuperAdmin,
  //       title: 'common.system.manage_proxy',
  //       icon: 'fal fa-network-wired',
  //       url: uriConsts.sys.SYS_PROXY
  //     },
  //     {
  //       path: 'banner',
  //       display: 1,
  //       role: ROLES.Blog_Editor,
  //       title: 'common.system.manage_banner',
  //       icon: 'fal fa-image',
  //       url: uriConsts.sys.SYS_BANNER
  //     },
  //     {
  //       path: 'report-fmm',
  //       display: 1,
  //       role: ROLES.Admin,
  //       title: 'common.system.report_fmm',
  //       icon: 'fal fa-chart-line',
  //       url: uriConsts.sys.SYS_REPORT_FMM
  //     },
  //   ]
  // }
]
